<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="middle-name">Отчество</label>
    <input
      type="text"
      class="form-control"
      id="middle-name"
      placeholder="Введите отчество"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'client-middle-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientMiddleName.vue?26e32753